<template>
    <div class="image-modal" @click="$emit('modal-click')" v-show="source">
        <div class="modal-content">
            <h2>{{ title }}</h2>
            <img v-if="source" @click="$emit('image-click')" :src="source" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ImageModal',
    props: ['source', 'title'],
};
</script>

<style scoped></style>
